import * as request from "../utils/request"

/* global MidasAds */
function initMidasAds() {
  return new Promise((resolve, reject) => {
    if (window.MidasAds) {
      resolve(MidasAds)
    } else {
      request
        .getScript("//midas.gtimg.cn/h5/store/util/midas-ads.min.js")
        .then(() => {
          resolve(MidasAds)
        })
        .catch(e => {
          reject(e)
        })
    }
  })
}

export function getAds(url, busId) {
  return initMidasAds().then(MidasAds => {
    return request
      .ajax({
        url: url,
        data: {
          timestamp: +new Date()
        }
      })
      .then(data => {
        let ads = new MidasAds({ data })
        let adsInfo = ads.get(busId ? busId.toString() : "")
        if (adsInfo.length > 0) {
          return Promise.resolve(adsInfo)
        } else {
          return Promise.resolve("")
        }
      })
  })
}
